import { notification } from 'antd'
import { Dispatch, useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { menuUrls } from 'src/app/shared/constants/menu.constants'
import { getIssuedCheckProcessingResult } from 'src/app/shared/services/IssuedCheckService'

export interface IResultScreenHook {
  resultList: any
  isGettingList: boolean
  setResultList: Dispatch<any>
  getResultList: (payload: Partial<any>, isDownload?: boolean) => Promise<void>
}

export const useResultScreen = (): IResultScreenHook => {
  const [resultList, setResultList] = useState<any>({
    data: [],
    total: 0,
    pageIndex: 0,
    pageSize: 10,
  })
  const [api] = notification.useNotification()
  const { t } = useTranslation()
  const navigate = useNavigate()

  const [isGettingList, setIsSettingList] = useState<boolean>(false)

  const getResultList = useCallback(
    async (payload: any, isDownload = false) => {
      try {
        if (!isDownload) {
          setIsSettingList(true)
        }
        let searchPayload = null
        const searchIssuedCheckLog = window.localStorage.getItem('issuedCheckLog')
        if (searchIssuedCheckLog) {
          searchPayload = JSON.parse(searchIssuedCheckLog)
        }
        if (searchPayload) {
          const res = await getIssuedCheckProcessingResult({
            ...payload,
            ...searchPayload,
            filterOption: payload?.filterOption ?? 0,
            isDesc: true,
          })
          if (res?.data && !isDownload) {
            setResultList(res?.data)
          }
          return res?.data
        } else {
          // NOTE: redirect to issued check processing log landing screen if no payload found
          navigate(menuUrls.issuedCheckProcessingLog)
        }
      } catch (error: any) {
        api.error({
          message: t('common:error'),
          description: `${error?.error}`,
          placement: 'topRight',
        })
      } finally {
        if (!isDownload) {
          setIsSettingList(false)
        }
      }
    },
    [api, navigate, t],
  )

  return {
    resultList,
    isGettingList,
    setResultList,
    getResultList,
  }
}
